import * as React from "react";
import { Field } from "formik";
import { Select } from "components/common";
import { PAGE_SIZES, DEFAULT_SIZE } from "report/Constants";
import ControlLabel from "components/bootstrap/ControlLabel";
import Input from "components/bootstrap/Input";
import { useTranslation } from "react-i18next";
const PageSizeSelect = ({ disabled }) => {
  const { t } = useTranslation("enterprise_report");
  return /* @__PURE__ */ React.createElement(Field, { name: "layout.pageSize" }, ({ field: { name, value, onChange }, meta: { error } }) => /* @__PURE__ */ React.createElement(Input, { id: name, error }, /* @__PURE__ */ React.createElement(ControlLabel, null, t("page_size_select.label")), /* @__PURE__ */ React.createElement(
    Select,
    {
      disabled,
      onChange: (newValue) => onChange({ target: { name, value: newValue } }),
      value: value != null ? value : DEFAULT_SIZE,
      inputId: name,
      placeholder: t("page_size_select.placeholder"),
      clearable: false,
      options: PAGE_SIZES
    }
  )));
};
export default PageSizeSelect;
